import { scienceAsset } from 'components/science/scienceAssets';

/** Landing-v2 images under `web_v2/science/landing/` via SpeedSize. */
export const scienceLandingAsset = (file: string): string =>
  scienceAsset(`/landing/${file}`);
